import { render, staticRenderFns } from "./ValidStickersPage.vue?vue&type=template&id=3bcf06f6&scoped=true&"
import script from "./ValidStickersPage.vue?vue&type=script&lang=ts&"
export * from "./ValidStickersPage.vue?vue&type=script&lang=ts&"
import style0 from "./ValidStickersPage.vue?vue&type=style&index=0&id=3bcf06f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf06f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VIcon,VPagination,VProgressCircular})
